<template>
  <modal-vue
    @close="handleToggleModal"
    :modalActive="modals[modalName]"
    :hasFooterBorder="true"
    :hasHeaderBorder="true"
    width="700px"
  >
    <template #header>
      <div class="px-4 text-left">
        <p class="font-bold text-lg">Criar Grupo</p>
      </div>
    </template>

    <div class="px-2">
      <base-form
        v-model:name="name"
        v-model:email="email"
        v-model:company="company"
        v-model:users="users"
      />
    </div>

    <template #footer>
      <v-row>
        <v-col cols="12" md="6">
          <outline-button @click="handleToggleModal" width="100%" text="Cancelar" />
        </v-col>
        <v-col cols="12" md="6">
          <filled-button
            :loading="isLoading"
            @click="handleCreate"
            text="Criar Grupo"
            height="52px"
            width="100%"
            :disabled="!isFormValid"
          />
        </v-col>
      </v-row>
    </template>
  </modal-vue>
</template>

<script setup lang="ts">
import { ref, onBeforeUnmount, computed } from 'vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import { storeToRefs } from 'pinia'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import { useGroupStore } from '@/pinia-store/useGroupStore'
import { useToast } from 'vue-toastification'
import { CreateGroupRequest } from '@/Network/Types/Requests/GroupRequests'
import BaseForm from './components/base.form.vue'
import { DEFAULT_MESSAGES } from '@/hooks/useCommon'

const modalName = EModals.CREATE_GROUP_MODAL
const { modals } = storeToRefs(useModalStore())
const modalStore = useModalStore()
const handleToggleModal = () => {
  modalStore.toggleModal(modalName)
}
const toast = useToast()
const groupStore = useGroupStore()

const isLoading = ref(false)
const name = ref<string>('')
const email = ref<string>('')
const company = ref<string | null>(null)
const users = ref<string[]>([])

const isFormValid = computed(() => {
  return name.value && company.value
})

const handleCreate = async () => {
  try {
    isLoading.value = true
    const payload: CreateGroupRequest = {
      name: name.value,
      email: email.value,
      companyId: Number(company.value),
      users: users.value.map((u) => Number(u))
    }
    await groupStore.create(payload)
    toast.success('Grupo criado com sucesso')
    handleToggleModal()
    clearAllInputs()
  } catch (error) {
    toast.error(DEFAULT_MESSAGES.error)
  } finally {
    isLoading.value = false
    await groupStore.getAllGroups()
  }
}

const clearAllInputs = () => {
  name.value = ''
  email.value = ''
  company.value = null
  users.value = []
}

onBeforeUnmount(() => {
  clearAllInputs()
})
</script>
